const QUERY_PARAMS = {
  elixir: ['elixir-v2-experience', 'dataApi'], // activate all these flags when ?elixir exists during mount.
};

// queryParamOverrides is defined when the application mounts. It allows
// for query params to be used to set override flags.
export const getFlagsOverridesFromQueryParams = (searchParams: URLSearchParams) => {
  return Object.entries(QUERY_PARAMS).reduce<{ [key: string]: boolean }>((result, [key, flagNames]) => {
    const paramValue = searchParams.get(key);

    if (!paramValue) {
      return result;
    }

    const logicalParamValue = paramValue !== 'false';

    const flagsToUpdate = flagNames.reduce<{ [key: string]: boolean }>((result, flagName) => {
      return {
        ...result,
        [flagName]: logicalParamValue,
      };
    }, {});

    return {
      ...result,
      ...flagsToUpdate,
    };
  }, {});
};
